// extracted by mini-css-extract-plugin
module.exports = {"headerContainer":"Header_headerContainer__3CNyn","addWidgetButton":"Header_addWidgetButton__uOYLL","dashboardTabs":"Header_dashboardTabs__3Igsy","active":"Header_active__3YlQ4"};